export type FileType = "code" | "json" | "html" | "text";

export const BROWSER_IMAGE_EXTENSIONS = new Set([
  "avif",
  "bmp",
  "gif",
  "ico",
  "jpeg",
  "jpg",
  "png",
  "svg",
  "webp",
]);

const SOURCE_TEXT_EXTENSIONS = new Set([
  "bash",
  "c",
  "cc",
  "cfg",
  "conf",
  "cpp",
  "cs",
  "css",
  "fish",
  "go",
  "gql",
  "graphql",
  "h",
  "hpp",
  "ini",
  "java",
  "js",
  "jsx",
  "kt",
  "kts",
  "less",
  "log",
  "py",
  "r",
  "rb",
  "rs",
  "sass",
  "scala",
  "scss",
  "sh",
  "sql",
  "svelte",
  "tex",
  "toml",
  "ts",
  "tsx",
  "vue",
  "xml",
  "zsh",
]);

export const BROWSER_TEXT_EXTENSIONS = new Set([
  ...SOURCE_TEXT_EXTENSIONS,
  "csv",
  "htm",
  "html",
  "json",
  "md",
  "tsv",
  "txt",
  "yaml",
  "yml",
]);

export const fileExtension = (filename: string): string =>
  filename.split(".").pop()?.toLowerCase() ?? "";

export const isBrowserImage = (filename: string): boolean =>
  BROWSER_IMAGE_EXTENSIONS.has(fileExtension(filename));

export const isHtmlFile = (filename: string): boolean => {
  const ext = fileExtension(filename);
  return ext === "html" || ext === "htm";
};

export const detectFileType = (filename: string): FileType => {
  const ext = fileExtension(filename);
  if (ext === "json") return "json";
  if (ext === "html" || ext === "htm") return "html";
  if (SOURCE_TEXT_EXTENSIONS.has(ext)) return "code";
  return "text";
};
